<ng-container>
    <div [ngClass]="wrapperClass" class="ispm-gallery-wrapper ispm-gallery-position{{thumbnailConfiguration?.thumbnailPosition.toLowerCase()}}">

        <div *ngIf="thumbnailConfiguration"
                class="ispm-image-thumbnail-container {{thumbnailConfiguration?.thumbnailScroll?'hideOverflow':''}}" (scroll)="thumbnailConfiguration?.thumbnailScroll?onScroll($event, thumbnailConfiguration?.thumbnailPosition.toLowerCase()=='top'||'bottom'?
                  true:false?'horizontal':'vertical'):null" >
            <div class="ispm-image-thumbnail show-{{this.thumbnailConfiguration?.thumbnailShowCount}} "
                 [id]="'ispm-auto-image-thumbnail-'+ file?.id"
                 *ngFor="let file of _thumbnailCollections; let isFirst = first; let isLast = last"
                 [ngClass]="{'selected': file?.id === _selectedThumbnail?.id}"
                 (click)="onThumbnailSelected(file, isFirst, isLast,false)">
             <span class="ispm-image-thumbnail-content">
<!--                    <span class="image-container">-->
                 <!--                        <img class="ispm-thumbnail-frame-image"-->
                 <!--                             [src]="image.source"-->
                 <!--                             [alt]="image.title">-->
                 <!--                    </span>-->
                     <span class="ispm-thumbnail-title">{{file.friendlyName}}</span>
                    <i
                            class="report-delete-icon"
                            (click)="deleteReport(file); $event.stopPropagation()"
                            [ngClass]="'pancancer__icon__CrossCircle1'"></i>
                </span>
            </div>
            <ng-container *ngIf="!thumbnailConfiguration?.thumbnailScroll">
                <div class="ispm-thumbnail-navigator navigation-left"
                     [id]="'ispm-auto-image-navigator-left'"
                     *ngIf="thumbnailConfiguration?.thumbnailPosition.toLowerCase() === 'top' || thumbnailConfiguration?.thumbnailPosition.toLowerCase() === 'bottom'"
                     (click)="navigateThumbnail('previous')">
                    <i class="icon__NavigationLeft1"></i>
                </div>

                <div class="ispm-thumbnail-navigator navigation-right"
                     [id]="'ispm-auto-image-navigator-right'"
                     *ngIf="thumbnailConfiguration?.thumbnailPosition.toLowerCase() ==='top'|| thumbnailConfiguration?.thumbnailPosition.toLowerCase() === 'bottom'"
                     (click)="navigateThumbnail('next')">
                    <i class="icon__NavigationRight2"></i>
                </div>
                <div class="ispm-thumbnail-navigator navigation-down"
                     [id]="'ispm-auto-image-navigator-down'"
                     *ngIf="thumbnailConfiguration?.thumbnailPosition.toLowerCase() ==='left'|| thumbnailConfiguration?.thumbnailPosition.toLowerCase() === 'right'"
                     (click)="navigateThumbnail('next')">
                    <i class="icon__NavigationDown"></i>
                </div>

                <div class="ispm-thumbnail-navigator navigation-up"
                     [id]="'ispm-auto-image-navigator-up'"
                     *ngIf="thumbnailConfiguration?.thumbnailPosition.toLowerCase() ==='left'|| thumbnailConfiguration?.thumbnailPosition.toLowerCase() === 'right'"
                     (click)="navigateThumbnail('previous')">
                    <i class="icon__NavigationUp"></i>
                </div>
            </ng-container>

        </div>


        <div class="ispm-image-full-view {{!thumbnailConfiguration?'fullwidth':''}}" >
            <gen-file-viewer
                    class = "img" *ngIf = "selectedFileContent | async as selectedFileContent; else loading"
                    [fileBase64Content]="selectedFileContent"
                    (click)="_selectedThumbnail.contentType!=='mp4'?toggleFullView($event):null"
                    [file]="_selectedThumbnail">
            </gen-file-viewer>

            <div class="ispm-image-navigator navigation-left"
                 [id]="'ispm-auto-image-navigator-left'"
                 *ngIf="!isFirst && showNavigationIcons"
                 (click)="onNavigate('previous')">
                <i class="icon__NavigationLeft1"></i>
            </div>

            <div class="ispm-image-navigator navigation-right"
                 [id]="'ispm-auto-image-navigator-right'"
                 *ngIf="!isLast && showNavigationIcons"
                 (click)="onNavigate('next')">
                <i class="icon__NavigationRight2"></i>
            </div>

        </div>


    </div>
    <ng-template #loading>
        <!--<gen-overlay-loader class="loader" *ngIf="downloading" [showOverlay]="false"></gen-overlay-loader>-->
        <gen-overlay-loader class="loader" [showOverlay]="false"></gen-overlay-loader>
    </ng-template>
</ng-container>

<div *ngIf="showFullView"
     class="ispm-image-full-zoom-view"
     [id]="'ispm-auto-image-full-zoom-view'">
    <i (click)="toggleFullView($event)" class="icon__CrossCircle1"></i>
    <gen-file-viewer
            class = "img" *ngIf = "selectedFileContent | async as selectedFileContent; else loading"
            [fileBase64Content]="selectedFileContent"
            (click)="toggleFullView($event)"
            [file]="_selectedThumbnail">
    </gen-file-viewer>
</div>

